import "./LandingPage.css";
import image1 from "../../images/LandingPageImage/godfrey-phillips-india-limited-logo.png";
import image2 from "../../images/LandingPageImage/Mars_Logo.png";
import image3 from "../../images/LandingPageImage/ampm logo.png";
import image4 from "../../images/LandingPageImage/Chattora Punjab.png";
import image5 from "../../images/LandingPageImage/Elogist.png";
import image6 from "../../images/LandingPageImage/unilever logo.png";
import image7 from "../../images/LandingPageImage/Great_Learning_Logo.png";
import image8 from "../../images/LandingPageImage/Dairy Day Logo.png";
import image9 from "../../images/LandingPageImage/Britannia.png";
import image10 from "../../images/LandingPageImage/Chattora Punjab.png";
import image11 from "../../images/LandingPageImage/Royal Spice.png";
import image12 from "../../images/LandingPageImage/salim Mughlai.png";
import image13 from "../../images/LandingPageImage/kamlesh dhaba.png";
import image14 from "../../images/LandingPageImage/new madras cafe.png";
import image15 from "../../images/LandingPageImage/T3 Cafe & Restaurant.png";
import image16 from "../../images/LandingPageImage/Raja Bhojnalaya.png";
import image17 from "../../images/LandingPageImage/My Girdhari lal.png";
import image18 from "../../images/LandingPageImage/punjabi dhaba logo.png";
import image19 from "../../images/LandingPageImage/madras cafe.png";
import image20 from "../../images/LandingPageImage/Kwality Veg.png";
import image21 from "../../images/LandingPageImage/Theturtleslogo.png";
import image22 from "../../images/LandingPageImage/The Chaap Grill.png";
import image23 from "../../images/LandingPageImage/Sachdeva Chicken.png";
import image24 from "../../images/LandingPageImage/Shree Urban Fastfood.png";
import image25 from "../../images/LandingPageImage/Urmi.png";
import image26 from "../../images/LandingPageImage/Chawla Veg Kitchen Logo 1.png";
import image27 from "../../images/LandingPageImage/JFC 1.png";
import image28 from "../../images/LandingPageImage/Handi Highway Dining.png";
import image29 from "../../images/LandingPageImage/Ashish G Chaap.png";
import image30 from "../../images/LandingPageImage/DB Chinese & Restaurant 1.png";
import image31 from "../../images/LandingPageImage/urbanrestaurant.png";
import image32 from "../../images/LandingPageImage/Veg Mantra.png";

const LogoScroll = () => {
  const logos = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
    image20,
    image21,
    image22,
    image23,
    image24,
    image25,
    image26,
    image27,
    image28,
    image29,
    image30,
    image31,
    image32,
  ];

  return (
    <div className="w-full py-10 bg-white overflow-hidden">
      <style>
        {`
          @keyframes scroll-left {
            from { transform: translateX(0); }
            to { transform: translateX(-25%); }
          }

          .scroll-track {
            animation: scroll-left 30s linear infinite;
          }

          @media (max-width: 768px) {
            .scroll-track {
              animation-duration: 24s;
            }
          }
        `}
      </style>

      <div className="max-w-[2000px] mx-auto overflow-hidden text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-green-600 mb-10">
          Trusted by 500+ Restaurants Across India
        </h2>

        <div className="flex w-max scroll-track">
          {[...logos, ...logos, ...logos, ...logos].map((logo, index) => (
            <div key={index} className="flex items-center px-5 flex-shrink-0">
              <img
                src={logo}
                alt="brand-logo"
                className="h-20 md:h-20 sm:h-10 object-contain opacity-90 hover:opacity-100 transition duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogoScroll;
